var map = {
	"./AKB-logo 1080.png": "7084",
	"./UAJY.png": "6813",
	"./carousel1.jpg": "3e00",
	"./carousel2.jpg": "562b",
	"./carousel3.jpg": "59fe",
	"./commitment.jpg": "0cc1",
	"./dashboard/bahan.jpg": "312c",
	"./dashboard/customers.jpg": "2394",
	"./dashboard/history.jpg": "ca4f",
	"./dashboard/karyawan.jpg": "de8e",
	"./dashboard/ketersediaan.jpg": "2ab9",
	"./dashboard/laporanstok.jpg": "5bb7",
	"./dashboard/meja.jpg": "3a8d",
	"./dashboard/menu.jpg": "de20",
	"./dashboard/pendapatan.jpg": "ce38",
	"./dashboard/pengeluaran.jpg": "5d6f",
	"./dashboard/penjualan.jpg": "1093",
	"./dashboard/pesanan.jpg": "0c82",
	"./dashboard/qrcode.jpg": "ee20",
	"./dashboard/reservasi.jpg": "1814",
	"./dashboard/stock.jpg": "50d5",
	"./dashboard/transaksi.jpg": "447e",
	"./no-image.png": "529b",
	"./test1.jpg": "5d63",
	"./test2.jpg": "c411",
	"./web.png": "6436"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";